function AuthScreen({ username, password, authError, onUsernameChange, onPasswordChange, onSubmit }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-100 p-4 text-slate-900">
      <section className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-6 shadow-xl">
        <div className="mb-4 mt-2 flex items-center gap-3">
          <img src="/logo/logo-full.png" alt="euz-lab" className="h-10 w-auto object-contain" />
        </div>
        <form className="grid gap-3" onSubmit={onSubmit}>
          <input
            className="rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none ring-brand-500 transition focus:ring"
            type="text"
            placeholder="Username or email"
            value={username}
            onChange={(event) => onUsernameChange(event.target.value)}
            required
          />
          <input
            className="rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none ring-brand-500 transition focus:ring"
            type="password"
            placeholder="Password (min 6 characters)"
            value={password}
            onChange={(event) => onPasswordChange(event.target.value)}
            minLength={6}
            required
          />
          <button className="rounded-xl bg-brand-500 px-4 py-3 text-sm font-semibold text-white transition hover:bg-brand-700" type="submit">
            Sign in
          </button>
          {authError && <p className="text-sm text-red-600">{authError}</p>}
        </form>
      </section>
    </main>
  );
}

export default AuthScreen;
